/**
 * Custom hook to fetch recommendations context for a given page type
 */

import {useEffect, useState} from 'react';

import {
    fetchRecommendationsContext,
    FetchRecommendationsContextOptions,
    RecommendationUnitGroup,
} from '@udemy/react-recommendations';

export const useRecommendationsContext = (options: FetchRecommendationsContextOptions) => {
    const [state, setState] = useState<{
        isLoading: boolean;
        error: unknown | null;
        units: RecommendationUnitGroup[];
    }>({
        isLoading: true,
        error: null,
        units: [],
    });

    useEffect(() => {
        let cancelled = false;
        fetchRecommendationsContext(options)
            .then(
                (response) => response.recommendationContext.sections as RecommendationUnitGroup[],
            )
            .then((sections) => {
                if (cancelled) return;
                setState({units: sections, isLoading: false, error: null});
            })
            .catch((error) => {
                if (cancelled) return;
                setState({units: [], isLoading: false, error});
            });
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return state;
};
